import * as React from 'react';
import { createContext, useContext, useEffect, useState } from 'react';
import { getRequest } from '../../../Helper/ApiClient';
import { Ncw } from '../../../../Interface/Ncw';

interface BasketHeaderInfo {
  total_quantity: number;
  total_price: number;
  is_backorder_confirmation: boolean;
}

interface INcwContext {
  ncw: Ncw | null;
  basketInfo: BasketHeaderInfo | null;
  loading: boolean;
  isSuccess: boolean;
  refetchNcwBasketHeader: () => void;
}

const NcwContext = createContext<INcwContext>({
  ncw: null,
  basketInfo: null,
  loading: false,
  isSuccess: false,
  refetchNcwBasketHeader: () => {},
});

export function NcwProvider({ children }: any) {
  const [ncw, setNcw] = useState<Ncw | null>(null);
  const [basketInfo, setBasketInfo] = useState<BasketHeaderInfo | null>(null);

  const ncwRequest = getRequest<Ncw>(
    '/api/onlineshop/newcomer-week/current-ncw'
  );
  const basketHeaderRequest = getRequest<BasketHeaderInfo>(
    '/api/onlineshop/newcomer-week/basket-header'
  );

  useEffect(() => {
    if (basketHeaderRequest.isSuccess && basketHeaderRequest.data) {
      setBasketInfo(basketHeaderRequest.data);
    } else {
      setBasketInfo(null);
    }
  }, [basketHeaderRequest.data]);

  useEffect(() => {
    if (ncwRequest.isSuccess && ncwRequest.data) {
      setNcw(ncwRequest.data);
    } else {
      setNcw(null);
    }
  }, [ncwRequest.data]);

  const refetchNcwBasketHeader = () => {
    basketHeaderRequest.refetch();
  };

  return (
    <NcwContext.Provider
      value={{
        ncw,
        basketInfo,
        refetchNcwBasketHeader,
        loading: basketHeaderRequest.isPending,
        isSuccess: ncwRequest.isSuccess
      }}
    >
      {children}
    </NcwContext.Provider>
  );
}

export function useNcw() {
  const context = useContext(NcwContext);
  if (!context) {
    throw new Error('useNcw() must be used within NcwProvider');
  }
  return context;
}
